var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-template',{staticClass:"profile-page",attrs:{"title":_vm.$t('profile')}},[_c('personal-info')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }